<template>
    <ContentOrLoading>
        <div class="p-3" v-if="!loading">
            <div class="text-right mb-4">
                <button 
                    class="btn btn-primary" 
                    @click.prevent="guardarPrecios(zonas)"
                    :disabled="loading"
                >
                    Guardar todos
                </button>
            </div>
            <div v-if="zonas.length === 0" class="text-center">
                No hay zonas disponibles para configurar.
            </div>
            
            <template v-for="(zona, index) in zonas">
                <div class="row align-items-center mb-4" :key="zona.id">
                    <div class="col-12 col-md-10">
                        <div class="row">
                            <div class="col-12 col-md-2 text-center">
                                <strong>{{ zona.name }}</strong>
                            </div>
                            
                            <div class="col-12 col-md-5">
                                <label v-if="index === 0">Precio Taquilla:</label>
                                <multiselect
                                    v-model="zona.precios_taquilla"
                                    placeholder="Precios taquilla"
                                    :custom-label="customLabel"
                                    label="description"
                                    track-by="id"
                                    :options="preciosDisponibles"
                                    :multiple="true"
                                    :show-labels="false"
                                    class="mb-2 mb-md-0"
                                    @select="zona.changed = true"
                                    @remove="zona.changed = true"
                                />
                            </div>
                            
                            <div class="col-12 col-md-5">
                                <label v-if="index === 0">Precios Online:</label>
                                <multiselect
                                    v-model="zona.precios_online"
                                    placeholder="Precios online"
                                    :custom-label="customLabel"
                                    label="description"
                                    track-by="id"
                                    :options="preciosDisponibles"
                                    :multiple="true"
                                    :show-labels="false"
                                    class="mb-2 mb-md-0"
                                    @select="zona.changed = true"
                                    @remove="zona.changed = true"
                                />
                            </div>
                        </div>
                        
                        <div v-if="esMovil" class="col-12 text-right p-0 mt-2">
                            <button class="btn btn-primary w-100" @click.prevent="guardarPrecios([zona])" :disabled="loading">
                                Guardar
                            </button>
                        </div>
                    </div>
                    
                    <div v-if="!esMovil" class="col-2 text-right">
                        <button class="btn btn-primary" @click.prevent="guardarPrecios([zona])" :disabled="loading">
                            Guardar
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </ContentOrLoading>
</template>

<script>
    export default {
        data() {
            return {
                zonas: [],
                loading: false,
                preciosDisponibles: []
            }
        },
        
        created() {
            this.getPreciosParcelas(); 
            this.getZonas();
        },
        
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        
        methods: {            
            async getPreciosParcelas() {
                this.loading = true;
                
                try {
                    const response = await this.$store.dispatch('BACK_PRECIOS_PARCELAS', {
                        lista_id: this.lista.id,
                        to_select: true,
                    });
                    if (response.data && response.data.data) {
                        this.preciosDisponibles = response.data.data;
                    }
                } catch (error) {
                    this.$toast.error("Error al cargar precios");
                } finally {
                    this.loading = false;
                }
            },
            
            async getZonas() {
                this.loading = true;
                
                try {
                    const response = await this.$store.dispatch('BACK_OBTENER_ZONAS_PRECIOS_PARCELAS', {
                        lista_id: this.lista.id,
                        recinto_id: this.lista.recinto_parcela_id,
                    });
                    
                    if (response.data && response.data.data) {
                        this.zonas = response.data.data.map(zona => ({
                            ...zona, 
                            changed: false
                        }));
                    } else {
                        this.$toast.error("No se encontraron zonas");
                        this.zonas = [];
                    }
                } catch (error) {
                    this.$toast.error("Error al cargar zonas");
                    this.zonas = [];
                } finally {
                    this.loading = false;
                }
            },
            
            customLabel(item) {
                if (!item) return '';
                return `${item.description} (${item.precio}€)`;
            },
            
            async guardarPrecios(zonas) {
                this.loading = true;
                
                try {
                    const zonasFormateadas = zonas.map(zona => ({
                        id: zona.id,
                        precios_online: zona.precios_online.map(p => p.id),
                        precios_taquilla: zona.precios_taquilla.map(p => p.id)
                    }));

                    await this.$store.dispatch('BACK_VINCULAR_PRECIOS_PARCELAS_GUARDAR', {
                        lista_id: this.lista.id,
                        recinto_id: this.lista.recinto_parcela_id,
                        zonas: zonasFormateadas
                    });
                    
                    this.$toast.success("Precios guardados correctamente");                  
                    await this.getZonas();
                } catch (error) {
                    this.$toast.error("Error al guardar precios");
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>